"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
exports.TextEditor = (props) => {
    const { onUpdate, column, value, defaultValue, row, onBlur, ref, ...rest } = props;
    const [newValue, setNewValue] = react_1.useState(value);
    const { dataField } = column;
    const onSaveChange = () => {
        onUpdate(newValue);
    };
    const onInputChange = (e) => {
        const { value } = e.target;
        setNewValue(value);
    };
    return (react_1.default.createElement(reactstrap_1.Card, null,
        react_1.default.createElement(reactstrap_1.CardBody, null,
            react_1.default.createElement(reactstrap_1.FormGroup, null,
                react_1.default.createElement(reactstrap_1.Input, { onChange: onInputChange, value: newValue })),
            react_1.default.createElement(reactstrap_1.ButtonGroup, null,
                react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "primary", onClick: () => onSaveChange() }, "Done"),
                react_1.default.createElement(reactstrap_1.Button, { size: "sm", onClick: () => onUpdate(defaultValue) }, "Cancel")))));
};
//# sourceMappingURL=TextEditor.js.map